module.exports = __webpack_public_path__ + "media/images/en/upload-confirmation-ddec90d780875d0559019bff71a94300.png";